export default __webpack_public_path__ + "static/media/swap.08f06f37.svg";